export default __webpack_public_path__ + "static/media/android.dc8bc106.png";